// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2IijP","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3M5Sz"};